export default __webpack_public_path__ + "static/media/starburst.1586880a.png";